import { ConfigProvider } from 'antd';
import antAR from 'antd/locale/ar_EG';
import antEN from 'antd/locale/en_US';
import 'bootstrap/dist/css/bootstrap.min.css';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import i18n from 'i18next';
import { useRoutes } from 'react-router-dom';
dayjs.extend(utc);
dayjs.extend(timezone);

import useCheckUserData from './hooks/useCheckUserData';
import { selectTheme } from './redux/config/configSlice';
import { useAppSelector } from './redux/hooks';
import routes from './routes';

function App() {
  const theme = useAppSelector(selectTheme);
  const element = useRoutes(routes);

  useCheckUserData();

  const isArabic = i18n.language === 'ar';

  return (
    <ConfigProvider
      theme={theme}
      locale={isArabic ? antAR : antEN}
      direction={isArabic ? 'rtl' : 'ltr'}
    >
      {element}
    </ConfigProvider>
  );
}

export default App;
